/**
 * @generated SignedSource<<d3f940dbb04eea086a04fc66819911de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type InfectopharmCountry = "Deutschland" | "Oesterreich" | "Unknown" | "%future added value";
export type SupplyPrivateAddressInput = {
  city: string;
  clientMutationId?: string | null;
  country: InfectopharmCountry;
  postalCode: string;
  street: string;
};
export type PrivateAddressDialog_SupplyPrivateAddressMutation$variables = {
  input: SupplyPrivateAddressInput;
};
export type PrivateAddressDialog_SupplyPrivateAddressMutation$data = {
  readonly Viewer: {
    readonly RPC: {
      readonly supplyPrivateAddress: {
        readonly clientMutationId: string | null;
      } | null;
    };
  };
};
export type PrivateAddressDialog_SupplyPrivateAddressMutation = {
  response: PrivateAddressDialog_SupplyPrivateAddressMutation$data;
  variables: PrivateAddressDialog_SupplyPrivateAddressMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ViewerMutationType",
    "kind": "LinkedField",
    "name": "Viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RPCViewerMutationSchema",
        "kind": "LinkedField",
        "name": "RPC",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "SupplyPrivateAddressPayload",
            "kind": "LinkedField",
            "name": "supplyPrivateAddress",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PrivateAddressDialog_SupplyPrivateAddressMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PrivateAddressDialog_SupplyPrivateAddressMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f3d48f5188d41f66f7c2ee7eb041ba01",
    "id": null,
    "metadata": {},
    "name": "PrivateAddressDialog_SupplyPrivateAddressMutation",
    "operationKind": "mutation",
    "text": "mutation PrivateAddressDialog_SupplyPrivateAddressMutation(\n  $input: SupplyPrivateAddressInput!\n) {\n  Viewer {\n    RPC {\n      supplyPrivateAddress(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ada46425235490a5e9144d99a01a326";

export default node;
